/**
 * TanStack Query hook for a project's design-package attachment.
 * The floorplan canvas (M8.3) consumes this to know which attachment
 * holds the PDF + which page index is the floorplan (R1.1).
 */
import { useQuery } from '@tanstack/react-query';
import type { Attachment } from '@vari-crew/schemas';
import { apiCall, ApiError } from '@/lib/api';

export function useDesignPackage(projectId: string | undefined) {
  return useQuery<Attachment | null>({
    queryKey: ['projects', projectId, 'design-package'],
    enabled: !!projectId,
    queryFn: async () => {
      try {
        return await apiCall<Attachment>(
          `/projects/${projectId}/design-package`,
        );
      } catch (err) {
        // A missing design package is a normal state (we surface it as a
        // "no floorplan uploaded yet" UI), not an error.
        if (err instanceof ApiError && err.status === 404) return null;
        throw err;
      }
    },
  });
}
